<div class="grid container align-center">
	<div [class]="this.pdfCss">
		<div class="card-task-detail relative">
			<div *ngIf="!hasError">
				<app-pdf-file-panel
					(assignWorkflow)="assign($event)"
					(completeWorkflow)="complete($event)"
					(goToNextTaskClicked)="this.goToNextTask()"
					(goToPreviousClicked)="this.goToPreviousTask()"
					(groupChange)="this.groupSelected($event)"
					(reOpenWorkflow)="reOpen($event)"
					(resendWorkflowCompletion)="this.resend($event)"
					(reviewClicked)="this.onReview()"
					(uploadFile)="this.uploadWorkflowFile($event)"
					[aiData]="aiData"
					[containerId]="this.mainPdfContainer"
					[currentFile]="this.primaryFile"
					[currentTask]="this.currentTask"
					[flexCss]="this.flexCss"
					[hasFile]="this.primaryFile.storageId !== undefined"
					[isLoading]="this.isLoading"
					[isPrimary]="true"
					[isSubmitButtonDisabled]="this.isSubmitting"
					[pdfPanelInFocus]="this.pdfPanelInFocus"
					[phobosTaskInstance]="this.phobosTaskInstance"
					[showPanelPadding]="this.showPanelPadding"
				></app-pdf-file-panel>
			</div>
		</div>
	</div>

	<app-error-panel *ngIf="hasError"></app-error-panel>

	<div class="flex justify-content-center mx-3 pt-5">
		<div class="hidden xl:block">
			<app-round-button-left
				(LeftClick)="getOpenComment()"
				[hidden]="!this.pdfPanelInFocus"
			></app-round-button-left>

			<app-round-button-right
				(RightClick)="getOpenPdf()"
				[hidden]="this.pdfPanelInFocus"
			></app-round-button-right>
		</div>
	</div>

	<div *ngIf="!hasError" [class]="this.commentsCss">
		<div class="card relative">
			<app-document-side-panel
				(addComment)="openCommentDialog()"
				[aiData]="aiData"
				[currentTask]="this.currentTask"
				[hasPrimaryDocument]="this.primaryFile.documentId !== undefined"
				[isPhobos]="true"
				(taskInstanceRefreshRequested)="refreshTaskInstance()"
			></app-document-side-panel>
		</div>
	</div>

	<app-complete-form-dialog
		(dialogClose)="this.completeFormDialogClose()"
		[formId]="this.phobosTaskInstance.id"
		[isResend]="this.isResend"
		[isVisible]="this.isCompleteFormVisible"
	></app-complete-form-dialog>

	<app-add-coment-dialog
		(commentDialogClose)="this.onDialogClose()"
		[currentFile]="this.primaryFile"
		[isVisible]="this.isCommentDialogVisible"
		[processId]="this.phobosTaskInstance.id"
		[taskType]="WorkflowType.Form"
	></app-add-coment-dialog>
</div>
